var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMulti)?_c('div',{staticClass:"d-flex align-items-center mt-1"},[_c('i',{staticClass:"tim-icons text-danger icon-alert-circle-exc mr-2"}),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }